import { io, Socket } from "socket.io-client";
import { ServerToClientEvents, ClientToServerEvents } from "./socket-type";
import Cookies from "js-cookie";
import { WEBSOCKET_URL } from "../../../api/utils";

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(
  WEBSOCKET_URL,
  {
    path: "/api/socket.io",
    query: { token: Cookies.get("accessToken") },
    transports: ["websocket"],
    autoConnect: false, // Чтобы избежать автоподключения до готовности токена
  },
);
